export function execute(functionOrPromise, callback) {
    const result = functionOrPromise();
    if (result && result.then) {
        return result.then(callback);
    } else {
        return callback();
    }
}



// WEBPACK FOOTER //
// ./services/CallbackService.js